module.exports = __webpack_public_path__ + "static/media/icon.13fad671.png";